import { Application } from "./scripts/Application";

const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);
canvasDiv.appendChild(Application.instance.view);

Application.instance.init();